import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { xpoAuthCanMatch } from '@xpo-ltl/ngx-auth';
import { LinealFeetComponent } from './linealFeet/linealFeet.component';

const routes: Routes = [
  {
    path: 'lineal',
    component: LinealFeetComponent,
    canMatch: [xpoAuthCanMatch()],
  },
  { path: '', redirectTo: 'lineal', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
